export default __webpack_public_path__ + "static/media/VEB_GroupLimitedIndemnity.7e44e911.png";